import { render, staticRenderFns } from "./types.vue?vue&type=template&id=b37518b8&"
import script from "./types.vue?vue&type=script&lang=js&"
export * from "./types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports